// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__ptd7q","title":"styles_title__ucPNO"};